export default __webpack_public_path__ + "static/media/6.19cc0fe3.png";